// src/context/NotificationContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { messagingPromise, onMessage } from '../firebase-config';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    if (!isRegistered) {
      messagingPromise.then((messaging) => {
        if (messaging) {
          onMessage(messaging, (payload) => {
            const newNotification = {
              title: payload.notification?.title,
              body: payload.notification?.body,
              data: payload.data || {},
              timestamp: new Date().toISOString()
            };

            setNotifications((prev) => [...prev, newNotification]);
          });

          setIsRegistered(true);
        }
      });
    }
  }, [isRegistered]);

  return (
    <NotificationContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
};

// Hook to access it easily
export const useNotification = () => useContext(NotificationContext);
